// test2576
(2576 && 0);
